import {Box, Flex, Image, Space, Text} from "@mantine/core";
import {Carousel} from "@mantine/carousel";
import {IconPlus} from "@tabler/icons-react";
import {decode} from 'html-entities';

import { useRef } from '@wordpress/element';
import Autoplay from 'embla-carousel-autoplay';
import ProductPlaceholderImage from '../../../../../assets/images/product_placeholder.png';

const _PopularProduct = ({component}) => {
    const autoplay = useRef(Autoplay({ delay: 4000 }));

    return (
        <Box
            bg={component?.customize_styles?.general_decoration?.background_color}
            mx={component?.customize_styles?.general_decoration?.margin_x}
            my={component?.customize_styles?.general_decoration?.margin_y}
            px={component?.customize_styles?.general_decoration?.padding_x}
            py={component?.customize_styles?.general_decoration?.padding_y}
            style={{
                boxShadow: `#00000014 ${component?.customize_styles?.general_decoration?.shadow_offset_x}px ${component?.customize_styles?.general_decoration?.shadow_offset_y}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px`,
                borderRadius: `${component?.customize_styles?.general_decoration?.border_radius}px`,
                border: `${component?.customize_styles?.general_decoration?.border_width}px solid ${component?.customize_styles?.general_decoration?.border_color}`,
            }}
        >
            <Text
                // bg={component?.customize_styles?.text_decoration?.background_color}
                fz={component?.customize_styles?.text_decoration?.font_size}
                fw={component?.customize_styles?.text_decoration?.font_weight}
                c={component?.customize_styles?.text_decoration?.color}
                mx={component?.customize_styles?.text_decoration?.margin_x}
                my={component?.customize_styles?.text_decoration?.margin_y}
                px={component?.customize_styles?.text_decoration?.padding_x}
                py={component?.customize_styles?.text_decoration?.padding_y}
            >
                {component?.customize_properties?.label}
            </Text>
            <Space h="xl"/>
            <Carousel
                slideSize="55%"
                slideGap={0}
                align="start"
                withControls={false}
                plugins={[autoplay.current]}
                onMouseEnter={autoplay.current.stop}
                onMouseLeave={autoplay.current.reset}
                loop
                styles={{
                    viewport: {
                        overflow: "visible",
                        overflowX: "clip",
                    },
                    indicators: {
                        position: "absolute",
                        top: "-22%",
                        right: "-78%",
                    },
                    indicator: {
                        backgroundColor: 'var(--mantine-color-gray-3)',
                        width: 10,
                        height: 10,
                        borderRadius: "100%",
                        '&[data-active="true"]': {
                            width: 20,
                            height: 20,
                            backgroundColor: 'var(--mantine-color-orange-5)',
                        },

                    }

                }}
            >
                {
                    component?.items?.map((item, index) => (
                        <Carousel.Slide
                            key={index}
                            h={230}
                            // w={`50%`}
                            mx={component?.customize_styles?.box_decoration?.margin_x}
                            my={component?.customize_styles?.box_decoration?.margin_y}
                            px={component?.customize_styles?.box_decoration?.padding_x}
                            py={component?.customize_styles?.box_decoration?.padding_y}
                            bg={component?.customize_styles?.box_decoration?.background_color}
                            pos="relative"
                            style={{
                                boxShadow: `#00000014 ${component?.customize_styles?.box_decoration?.shadow_offset_x}px -${component?.customize_styles?.box_decoration?.shadow_offset_y}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px`,
                                borderRadius: `${component?.customize_styles?.box_decoration?.border_radius}px`,
                                display: "flex",
                                alignItems: "flex-end",
                                border: `${component?.customize_styles?.box_decoration?.border_width}px solid ${component?.customize_styles?.box_decoration?.border_color}`,
                            }}
                        >
                            <Box
                                pos="absolute"
                                top="-30px"
                                left="10%"
                                // ta="center"
                                w={`80%`}
                                h={167}
                                // bg={component?.customize_styles?.image_decoration?.color}
                                style={{
                                    borderRadius: `${component?.customize_styles?.image_decoration?.radius}px`,
                                }}
                            >
                                <Image
                                    src={item.image_url}
                                    fallbackSrc={ProductPlaceholderImage}
                                    alt="Product"
                                    radius={component?.customize_styles?.image_decoration?.radius}
                                    style={{ width: "100%", height: "100%" }}
                                />
                            </Box>

                            <Box td="none" mx="10%" w={`100%`}>
                                <Text
                                    lineClamp={1}
                                    translate="yes"
                                    c={component?.customize_styles?.name_text_decoration?.color}
                                    fw={component?.customize_styles?.name_text_decoration?.font_weight}
                                    fz={component?.customize_styles?.name_text_decoration?.font_size}
                                    fs={component?.customize_styles?.name_text_decoration?.font_style}
                                >
                                    {item?.name}
                                </Text>
                                <Text
                                    c={component?.customize_styles?.product_category_text_decoration?.color}
                                    // bg={component?.customize_styles?.product_category_text_decoration?.background_color}
                                    fz={12}
                                    lineClamp={1}
                                    translate="yes"
                                >
                                    {item?.product_categories?.toString()}
                                    {item?.product_tags?.toString()}
                                </Text>
                                <Flex justify="space-between" align="center" pos="relative" w="100%">
                                    <Text
                                        c={component?.customize_styles?.product_price_text_decoration?.color}
                                        bg={component?.customize_styles?.product_price_text_decoration?.background_color}
                                        fw={component?.customize_styles?.product_price_text_decoration?.font_weight}
                                        fz={component?.customize_styles?.product_price_text_decoration?.font_size}
                                    >
                                        {decode(item?.currency)} {item?.discount_price ? item.discount_price : item?.price}
                                    </Text>

                                    <Flex
                                        align="center"
                                        justify="center"
                                        w={35}
                                        h={35}
                                        bg="linear-gradient(150deg, #4c6c93 0%, #649fa8 100%)"
                                        style={{ borderRadius: "10px" }}
                                        pos="absolute"
                                        bottom={0}
                                        right={0}
                                    >
                                        <IconPlus color="#ffffff" />
                                    </Flex>
                                </Flex>
                            </Box>
                        </Carousel.Slide>
                    ))
                }

            </Carousel>
        </Box>
    )
}
export default _PopularProduct;